import type { DocWorkflowAnswerType } from "~utils";

import { AccordionAnswer } from "./accordion-answer";
import { ContentAnswer } from "./content-answer";
import { TextAnswer } from "./text-answer";
import { UploadAnswer } from "./upload-answer";

export type { DocWorkflowAnswerType };

type AnswerProps = {
  answerType: DocWorkflowAnswerType;
  value?: string;
  onChange?: (value?: string) => void;
  isReadOnly?: boolean;
};

export function Answer(props: AnswerProps) {
  const { answerType, value, onChange, isReadOnly } = props;

  switch (answerType.type) {
    case "ACCORDION":
      return <AccordionAnswer {...answerType} />;
    case "CONTENT":
      return <ContentAnswer {...answerType} />;
    case "TEXT":
      return (
        <TextAnswer {...answerType} value={value} onChange={onChange} isReadOnly={isReadOnly} />
      );
    case "UPLOAD":
      return (
        <UploadAnswer {...answerType} onChange={onChange} isReadOnly={isReadOnly || !!value} />
      );
    default:
      return null;
  }
}
